module.exports = __webpack_public_path__ + "img/blockdit-2-active.496d582b.svg";